(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const cardsWrappers = document.querySelectorAll('.dynamic-accordion-wrapper');

    cardsWrappers.forEach((cardsWrapper) => {
      cardsWrapper.addEventListener('click', (event) => {
        const card = event.target.closest('.dynamic-accordion-card');
        if (card) {
          const cardExpandablenContent = card.querySelector('.dynamic-accordion-card-expanded');
          const chevron = card.querySelector('.dynamic-accordion-card-chevron');
          const button = card.querySelector('.dynamic-accordion-card-show-button');
          const buttonText = button.querySelector('span');
          const divider = card.querySelector('.dynamic-accordion-card-divider');

          const isModuleCardOpen = cardExpandablenContent.classList.contains('open');

          const openModuleCards = cardsWrapper.querySelectorAll('.dynamic-accordion-card-expanded.open');
          openModuleCards.forEach((openModuleCard) => {
            openModuleCard.style.maxHeight = null;
            openModuleCard.classList.remove('open');

            const moduleCard = openModuleCard.closest('.dynamic-accordion-card');
            const openDivider = moduleCard.querySelector('.dynamic-accordion-card-divider');
            const openButton = moduleCard.querySelector('.dynamic-accordion-card-show-button');
            const openChevron = openButton.querySelector('.dynamic-accordion-card-chevron');
            const openButtonText = openButton.querySelector('span');

            openButtonText.style.opacity = 0;
            setTimeout(() => {
              openButtonText.textContent = 'Mehr erfahren';
              openButtonText.style.opacity = 1;
            }, 150);

            openChevron.style.transform = 'rotate(90deg)';
            moduleCard.style.gap = '0px';
            openDivider.style.maxHeight = null;
          });

          if (!isModuleCardOpen) {
            cardExpandablenContent.style.maxHeight = cardExpandablenContent.scrollHeight + 'px';
            cardExpandablenContent.classList.add('open');
            divider.style.maxHeight = '2px';

            buttonText.style.opacity = 0;
            setTimeout(() => {
              buttonText.textContent = 'Weniger anzeigen';
              buttonText.style.opacity = 1;
            }, 150);

            chevron.style.transform = 'rotate(-90deg)';
            card.style.gap = window.innerWidth >= 320 && window.innerWidth <= 767 ? '24px' : '32px';
          }
        }
      });
    });
  });
})();
